"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPassword = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var ForgotPasswordForm_1 = __importDefault(require("./ForgotPasswordForm"));
var ForgotPasswordConfirm_1 = __importDefault(require("./ForgotPasswordConfirm"));
var ForgotPassword = function (_a) {
    var onCancel = _a.onCancel;
    var _b = (0, react_1.useState)(false), isForgotPasswordConfirm = _b[0], setIsForgotPasswordConfirm = _b[1];
    var onSubmit = function () { return setIsForgotPasswordConfirm(true); };
    return (0, jsx_runtime_1.jsx)("div", { children: !isForgotPasswordConfirm ?
            ((0, jsx_runtime_1.jsx)(ForgotPasswordForm_1.default, { onSubmit: onSubmit, onCancel: onCancel }, void 0)) :
            ((0, jsx_runtime_1.jsx)(ForgotPasswordConfirm_1.default, { onCancel: onCancel }, void 0)) }, void 0);
};
exports.ForgotPassword = ForgotPassword;
exports.default = exports.ForgotPassword;
